import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials : depuis le 16/10, la session voyage dans le cookie « access_token » (inaccessible aux scripts),
// plus dans un jeton rangé par le site. Le navigateur l'envoie seul ; il faut l'autoriser explicitement, y compris
// en local où le site (:3000) et le serveur (:8000) n'ont pas la même adresse.
const api = axios.create({ baseURL: API, withCredentials: true });

// Doubles clics (recette du 15/10, ANO-01) : une écriture identique (même adresse, même contenu) encore en cours n'est
// pas envoyée une seconde fois ; le second appel reçoit la réponse du premier. Sans cela, un double clic créait deux
// demandes, ou affichait une erreur trompeuse à côté du succès.
const inFlight = new Map();
const keyOf = (data) => {
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    return JSON.stringify([...data.entries()].map(([k, v]) => [k, typeof File !== "undefined" && v instanceof File ? `${v.name}:${v.size}:${v.lastModified}` : v]));
  }
  try { return JSON.stringify(data ?? null); } catch { return `${Math.random()}`; }
};
["post", "put", "patch", "delete"].forEach((method) => {
  const send = api[method].bind(api);
  api[method] = (url, ...args) => {
    const [data, config] = method === "delete" ? [args[0]?.data, args[0]] : args;
    const key = `${method} ${url} ${keyOf(config?.params)} ${keyOf(data)}`;
    if (inFlight.has(key)) return inFlight.get(key);
    const req = send(url, ...args).finally(() => inFlight.delete(key));
    inFlight.set(key, req);
    return req;
  };
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = String(error.config?.url || "");
    if (error.response?.status === 401 && !url.endsWith("/auth/login") && !url.endsWith("/auth/me")) {
      window.dispatchEvent(new Event("auth:expired"));  // AuthContext efface les repères de session
    }
    // Le user en mémoire côté client peut se retrouver désynchronisé de son
    // état réel côté serveur (ex. bundle chargé avant un déploiement) — sur
    // ce 403 précis, se resynchroniser via /auth/me plutôt que de rester
    // bloqué sur une page qui ne se chargera jamais.
    if (error.response?.status === 403 && error.response?.data?.detail === "ONBOARDING_REQUIRED" && !url.endsWith("/auth/me")) {
      window.dispatchEvent(new Event("auth:onboarding-required"));
    }
    return Promise.reject(error);
  }
);

export default api;
